import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Modal, ModalContext, Text } from 'dash-ui';

import {
  GetAmenitiesDocument,
  GetAmenitiesForManageDocument,
  GetPropertyByIdDocument,
  useRemoveAmenitiesFromPropertyMutation,
} from 'gql/generated.graphql';

import { PropertyFeaturesAndAmenityTabModalsEnum } from 'containers/properties/PropertyFeaturesAndAmenities/constants';

function RemoveAmenityModal() {
  const { t: tPropertyPage } = useTranslation('pages', {
    keyPrefix: 'propertyPage',
  });
  const { t: tCommonLabels } = useTranslation('common', {
    keyPrefix: 'labels',
  });

  const { isOpenCurrent, setPayload, payload, toggleModal } =
    useContext(ModalContext);
  const isOpen =
    !!isOpenCurrent[
      PropertyFeaturesAndAmenityTabModalsEnum.REMOVE_AMENITY_MODAL
    ];

  const onClose = () => {
    setPayload(null);
    toggleModal(
      false,
      PropertyFeaturesAndAmenityTabModalsEnum.REMOVE_AMENITY_MODAL
    );
  };

  const [mutation, { loading }] = useRemoveAmenitiesFromPropertyMutation({
    onCompleted: onClose,
    refetchQueries: [
      GetAmenitiesDocument,
      GetAmenitiesForManageDocument,
      GetPropertyByIdDocument,
    ],
  });

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      title={tPropertyPage`removeAmenityFromPropertyModalTitle` as string}
      submitButton={{
        title: tCommonLabels`confirm`,
        isLoading: loading,
        onClick: () =>
          mutation({
            variables: {
              propertyId: payload?.property?._id,
              amenitiesIds: [payload?.amenity?._id],
            },
          }),
      }}
      cancelButton={{
        title: tCommonLabels`cancel`,
        onClick: onClose,
      }}
    >
      <Box my={6}>
        <Text>
          {tPropertyPage(`removeAmenityFromPropertyModalText`, {
            amenityName: payload?.amenity?.name,
          })}
        </Text>
      </Box>
    </Modal>
  );
}

export default RemoveAmenityModal;
